module.exports = __webpack_public_path__ + "static/media/logo-comjoodoc-easy-lang-color-white.1664a952.png";